import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NavigationLink, Theme } from '@domgen/dgx-fe-common';
import { DgxIconName, IconComponent } from '@domgen/dgx-fe-components/icon';
import { Image, PictureComponent } from '@domgen/dgx-fe-components/media';

@Component({
  selector: 'smart-fix-reminder-text',
  standalone: true,
  imports: [NgIf, IconComponent, PictureComponent],
  templateUrl: './reminder-text.component.html',
  styleUrls: ['./reminder-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartFixCustomReminderComponent {
  @Input() border = false;
  @Input() buttonIconName?: DgxIconName;
  @Input() description?: string;
  @Input() iconName?: DgxIconName;
  @Input() image?: Image;
  @Input() navigationLink?: NavigationLink;
  @Input() theme: Theme = 'background';
  @Input() title?: string;
}
